import { SxProps, Theme } from "@mui/material";

export default (theme: Theme): Record<string, SxProps<Theme>> => ({
  container: {
    flexDirection: "column",
    gap: "calc(2 * var(--rhythm))",
    p: "calc(2 * var(--rhythm))",
    displayPrint: "none",
    [theme.breakpoints.down("md")]: {
      gap: "calc(1 * var(--rhythm))",
      p: 0,
    },
  },

  download: {
    flexDirection: "row",
    p: "calc(2 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      p: "var(--rhythm)",
      borderRadius: 0,
    },
  },
});
